"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.validateEventValue = void 0;
var constants_1 = require("../../logger/constants");
var lang_1 = require("../lang");
function validateEventValue(log, maybeValue, method) {
    if ((0, lang_1.isFiniteNumber)(maybeValue) || maybeValue == undefined) // eslint-disable-line eqeqeq
        return maybeValue;
    log.error(constants_1.ERROR_NOT_FINITE, [method]);
    return false;
}
exports.validateEventValue = validateEventValue;
